import $ from 'jquery';
import debug from 'bows';

const log = debug('layout:tabs');

class LayoutTabs {
	constructor(options = {}) {
		this.defaults = {
			container: null,
			active: 'layout-tabs--active',
			navItem: 'layout-tabs__nav-item',
			navItemActive: 'layout-tabs__nav-item--active',
			navLink: 'layout-tabs__nav-link',
			tabs: 'layout-tabs__tab',
			tabActive: 'layout-tabs__tab--active'
		};

		options = $.extend({}, this.defaults, options);
		log(options);

		this.options = options;
		this.container  = options.container;
		this.$container = $(options.container);

		// this.bindEvents();
		this.init();
	}

	init() {
		const { active, navItem, navItemActive, navLink, tabs, tabActive } = this.options;

		log('container', this.container);
		this.$container.on('click.tabs', `.${navLink}`, (e) => {
			e.preventDefault();
			const $link = $(e.target);
			const $tabs = $(`.${tabs}`);
			const index = $link.data('index');
			log($link, index);
			$tabs.filter(`.${tabActive}`).removeClass(tabActive)
			$tabs.filter(`[data-index=${index}]`).addClass(tabActive);
			log(`[data-index=${index}]`);
			this.$container.find(`.${navItemActive}`).removeClass(navItemActive);
			$link.closest(`.${navItem}`).addClass(navItemActive);
		});

		this.$container.find(`.${navLink}`).first().trigger('click.tabs');
		this.$container.addClass(active);
	}
}

export default LayoutTabs;
